import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  iconButton: {
    padding: '10px',
  },
}));
